import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import '/src/assets/tailwind.css'
import i18n from './i18n'; // Archivo de configuración de i18n
/* eslint-disable vue/multi-word-component-names */
import { Icon } from '@iconify/vue2';
/* eslint-disable vue/multi-word-component-names */
Vue.component('Icon', Icon);

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
